
import Vue from "vue";
import PlaceCardsWrapper from "./place-cards-wrapper.vue";
import CurrentMonitor from "./current-monitor.vue";
export default Vue.extend({
  name: "pc",
  components: {
    CurrentMonitor,
    PlaceCardsWrapper,
  },
  
  props: ["floorPlan","placeIdHashList","vacancy","gender","monitorProps","monitorIdHash"],
  computed:{
    styles(){
      return {
        "--bg" : 'url("' + require('@/assets/base.svg') + ")",
      }
    },
  },
  mounted: function(){
    //console.log(this.gender);
  },
});
